import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminTranscriptPlayerPage = () => {
  return (
    <>
      <Helmet>
        <title>Transcript Player - AutoScript Admin</title>
      </Helmet>
      <Header title="Transcript Player" />

      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
